// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import OrderFormController from "./order_form_controller"
application.register("order-form", OrderFormController)

import BookingFormController from "./booking_form_controller"
application.register("booking-form", BookingFormController)

import CustomerSearchController from "./customer_search_controller"
application.register("customer-search", CustomerSearchController)

import PhotoPreviewController from "./photo_preview_controller"
application.register("photo-preview", PhotoPreviewController)

import SearchableSelectController from "./searchable_select_controller"
application.register("searchable-select", SearchableSelectController)
